import { render, staticRenderFns } from "./BrainTournamentKnives.vue?vue&type=template&id=ec1d90f0&scoped=true"
import script from "./BrainTournamentKnives.vue?vue&type=script&lang=js"
export * from "./BrainTournamentKnives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1d90f0",
  null
  
)

export default component.exports